import React, { useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { studyLevelFormManagementServices } from "../../../../../APIServices/studyLevelFormManagementServices";

const Signature = ({ Show, Hide, Title }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const digitalSignatureStudyLevelForm = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to signature provied to the report!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, sign it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.userId = userId;
        userData.password = password;
        userData.mode = StudyMode;
        let data =
          await studyLevelFormManagementServices.digitalSignatureStudyLevelForm(
            userData
          );
        if (data?.statusCode === 200) {
        //   if (StudyMode === "DBP Mode") {
        //     setDBPQualityCheck("yes");
        //   }
        //   if (StudyMode === "DV Mode") {
        //     setDVQualityCheck("yes");
        //   }
        //   getStudyLevelForm();
        //   getStudyLevelFormFieldsByVersion();
          Hide();
          setUserId("");
          setPassword("");
        }
        setButtonLoader(false);
      }
    });
  };
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Offcanvas.Body className="p-1">
            <Form.Group
              style={{ textAlign: "justify", fontSize: 13 }}
              className="mb-3"
            >
              <p className="m-0 br3 bg-success-subtle p-2">
                You are required to provide a signature for this activity in
                order to fully complete it. This records that you are signing
                off theat you have taken, and completed this online review
                activity. This will resilt in the completion record being
                recorded in your review history.
              </p>
            </Form.Group>
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold mb-1">
                UserId{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                onChange={(e) => setUserId(e.target.value)}
                value={userId}
                className="br3"
                placeholder="UserId"
                type="text"
              />
            </Form.Group>
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold mb-1">
                Password{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                className="br3"
                placeholder="Password"
                type="password"
              />
            </Form.Group>
          </Offcanvas.Body>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            disabled={buttonLoader}
            title={Title}
            onClick={(e) => digitalSignatureStudyLevelForm(e)}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Signing...
              </div>
            ) : (
              "Signature"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default Signature;
